import { isObject, toSafeObject, toSafeString } from '@shared/utils';
import resolvePieveWorkflowRunFailureDisplay from '@shared/pieve/workflowRunFailureDisplay.js';

// Builds the run-level failure banner: why the run failed, plus which execution row to scrub to so the reader lands on the
// step that actually failed rather than the container that reported it. `meta.failedStepId` names the failing step, so
// prefer the origin row matching it; otherwise take the first origin in execution order.
const buildWorkflowRunFailure = ({ failurePayload, rows, failureOriginIndexes, stepNameByStepId } = {}) => {
  if (!isObject(failurePayload)) {
    return null;
  }

  const origins = Array.isArray(failureOriginIndexes) ? failureOriginIndexes : [];
  const safeRows = Array.isArray(rows) ? rows : [];
  const failedStepId = toSafeString(failurePayload.meta?.failedStepId);
  const namedOrigin = failedStepId ? origins.find((index) => toSafeString(safeRows[index]?.stepId) === failedStepId) : undefined;
  const targetIndex = namedOrigin !== undefined ? namedOrigin : (origins[0] ?? null);
  const targetStepId = targetIndex === null ? '' : toSafeString(safeRows[targetIndex]?.stepId);
  const display = resolvePieveWorkflowRunFailureDisplay({ failure: failurePayload, stepNameByStepId });

  return {
    headline: display?.headline || null,
    // The runner's own words, kept beneath the headline: this modal is where a builder goes to debug,
    // so the sanitized sentence must not be the only account available.
    code: display?.code || null,
    detail: display?.detail || null,
    targetIndex,
    targetStepName: targetStepId ? toSafeString(toSafeObject(stepNameByStepId)[targetStepId]) || targetStepId : null
  };
};

export default buildWorkflowRunFailure;
